import { FighterSkillsInfo } from "../../../model/Dto/Skill";
import { ApiRequest, RequestMethod } from "../../request";

export async function getFighterSkills(fighterId: string): Promise<FighterSkillsInfo> {
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.GET);
  apiRequest.setUrl(`/api/fighter/${fighterId}/skills`);

  const response: any = await apiRequest.send();

  return {
    fighterExp: response.data.fighterExp,
    skillBranches: response.data.skillBranches.map((branch: any) => ({
      id: branch.id,
      name: branch.name,
      skills: branch.skills.map((skill: any) => ({
        id: skill.id,
        name: skill.name,
        alreadyPurchased: skill.alreadyPurchased
      }))
    }))
  };
}